export const areas = [
  {
    name: "AECS Layout",
    city: "Bangalore",
    centers: [
      { id: 95, km: 5, location: "https://maps.app.goo.gl/uZRNu1L1XMVUFEtXA" },
    ],
  },
  {
    name: "Akshayanagar",
    city: "Bangalore",
    centers: [
      { id: 80, km: 5, location: "https://maps.app.goo.gl/uiwDYBKiiwCXCmrv9" },
    ],
  },
  {
    name: "Ambedkar Nagar, Whitefield",
    city: "Bangalore",
    centers: [
      { id: 97, km: 5, location: "https://maps.app.goo.gl/TwnEAccGi9hZRrYA8" },
    ],
  },
  {
    name: "Ananth Nagar",
    city: "Bangalore",
    centers: [
      { id: 89, km: 5, location: "https://maps.app.goo.gl/Bo6zuq5hqStyqGjA7" },
    ],
  },
  {
    name: "Arekere",
    city: "Bangalore",
    centers: [
      { id: 101, km: 5, location: "https://maps.app.goo.gl/LYkTwTMqCv56Dzrb6" },
    ],
  },
  {
    name: "Ashok Nagar",
    city: "Bangalore",
    centers: [
      { id: 88, km: 5, location: "https://maps.app.goo.gl/rrNkWChdk2r5ns1V9" },
    ],
  },
  {
    name: "Bannerghatta Road",
    city: "Bangalore",
    centers: [
      { id: 94, km: 5, location: "https://maps.app.goo.gl/GFV4yLkMNRUG7FhF6" },
      { id: 87, km: 5, location: "https://maps.app.goo.gl/JFLZrKWXkVJaDxMS8" },
      { id: 101, km: 5, location: "https://maps.app.goo.gl/LYkTwTMqCv56Dzrb6" },
    ],
  },
  {
    name: "Bellandur",
    city: "Bangalore",
    centers: [
      { id: 68, km: 5, location: "https://maps.app.goo.gl/rxRQ1He17gjXfNms7" },
      { id: 83, km: 5, location: "https://maps.app.goo.gl/irEQE5998eRUARz58" },
    ],
  },
  {
    name: "Chikkabanavara",
    city: "Bangalore",
    centers: [
      { id: 91, km: 5, location: "https://maps.app.goo.gl/WkG6YKGVAj4uCvau6" },
    ],
  },
  {
    name: "Chinnapanna Halli",
    city: "Bangalore",
    centers: [
      { id: 95, km: 5, location: "https://maps.app.goo.gl/uZRNu1L1XMVUFEtXA" },
    ],
  },
  {
    name: "Electronic City",
    city: "Bangalore",
    centers: [
      { id: 89, km: 5, location: "https://maps.app.goo.gl/Bo6zuq5hqStyqGjA7" },
    ],
  },

  {
    name: "Gottigere",
    city: "Bangalore",
    centers: [
      { id: 94, km: 5, location: "https://maps.app.goo.gl/GFV4yLkMNRUG7FhF6" },
      { id: 87, km: 5, location: "https://maps.app.goo.gl/JFLZrKWXkVJaDxMS8" },
      { id: 101, km: 5, location: "https://maps.app.goo.gl/LYkTwTMqCv56Dzrb6" },
    ],
  },
  {
    name: "Hebbal",
    city: "Bangalore",
    centers: [
      { id: 70, km: 5, location: "https://maps.app.goo.gl/iAdGytxJk8yYVbDK6" },
      { id: 77, km: 5, location: "https://maps.app.goo.gl/dtF9wZKi7UpjJYE59" },
    ],
  },
  {
    name: "Hoodi",
    city: "Bangalore",
    centers: [
      { id: 99, km: 5, location: "https://maps.app.goo.gl/2G44qFyqrVeATayQ9" },
      { id: 69, km: 5, location: "https://maps.app.goo.gl/hx4sL5tBGHdRd7UY7" },
    ],
  },
  {
    name: "Horamavu",
    city: "Bangalore",
    centers: [
      { id: 74, km: 5, location: "https://maps.app.goo.gl/E7T1VojZMGjRYmq16" },
      { id: 72, km: 5, location: "https://maps.app.goo.gl/T62361cg8RLRzY6i7" },
      { id: 75, km: 5, location: "https://maps.app.goo.gl/KtVSWJ4B91gade7q9" }
    ],
  },
  {
    name: "J.P Nagar",
    city: "Bangalore",
    centers: [
      { id: 94, km: 5, location: "https://maps.app.goo.gl/GFV4yLkMNRUG7FhF6" },
      { id: 110, km: 5, location: "https://maps.app.goo.gl/zvcT7nxsSopDAcBv7" },
    ],
  },
  {
    name: "Kaggadasapura",
    city: "Bangalore",
    centers: [
      { id: 98, km: 5, location: "https://maps.app.goo.gl/PcsXb2EeQQeAoooo7" },
    ],
  },
  {
    name: "Kadugodi, Whitefield",
    city: "Bangalore",
    centers: [
      { id: 85, km: 5, location: "https://maps.app.goo.gl/NXNFkqiiYSkJT3bP8" },
    ],
  },
  {
    name: "Kasturi Nagar",
    city: "Bangalore",
    centers: [
      { id: 78, km: 5, location: "https://maps.app.goo.gl/4YMNmNSwyLd815aR9" },
    ],
  },
  {
    name: "Kothnur",
    city: "Bangalore",
    centers: [
      { id: 92, km: 5, location: "https://maps.app.goo.gl/X1QEM6m6jjhhb64L8" },
    ],
  },
  {
    name: "Kothnur Narayanapura",
    city: "Bangalore",
    centers: [
      { id: 96, km: 5, location: "https://maps.app.goo.gl/pAt4Vz2BwsduQ9Ys8" },
    ],
  },
  {
    name: "Kudlu",
    city: "Bangalore",
    centers: [
      { id: 93, km: 5, location: "https://maps.app.goo.gl/bhEcmBX5J23qKYJC7" },
    ],
  },
  {
    name: "Manyata Tech Park",
    city: "Bangalore",
    centers: [
      { id: 70, km: 5, location: "https://maps.app.goo.gl/6AAyrucYKceGwRxX6" },
      { id: 77, km: 5, location: "https://maps.app.goo.gl/dtF9wZKi7UpjJYE59" },
    ],
  },
  {
    name: "Marathahalli",
    city: "Bangalore",
    centers: [
      { id: 66, km: 5, location: "https://maps.app.goo.gl/j3ombBR7BDu9J9gn6" },
      { id: 82, km: 5, location: "https://maps.app.goo.gl/G2RLg35tzKVji7cF7" },
      { id: 95, km: 5, location: "https://maps.app.goo.gl/uZRNu1L1XMVUFEtXA" },
    ],
  },
  {
    name: "Mallasandra",
    city: "Bangalore",
    centers: [
      { id: 111, km: 5, location: "https://maps.app.goo.gl/HnDjdLMqbCTcZKM69" },
    ],
  },
  {
    name: "Parappana Agrahara",
    city: "Bangalore",
    centers: [
      { id: 93, km: 5, location: "https://maps.app.goo.gl/bhEcmBX5J23qKYJC7" },
    ],
  },
  {
    name: "RR nagar",
    city: "Bangalore",
    centers: [
      { id: 105, km: 5, location: "https://maps.app.goo.gl/omRKY3KeRocpHLvz6" }, 
    ],
  },
  {
    name: "Ramamurthy Nagar",
    city: "Bangalore",
    centers: [
      { id: 72, km: 5, location: "https://maps.app.goo.gl/T62361cg8RLRzY6i7" },
      { id: 74, km: 5, location: "https://maps.app.goo.gl/E7T1VojZMGjRYmq16" },
      { id: 75, km: 5, location: "https://maps.app.goo.gl/KtVSWJ4B91gade7q9" },
      { id: 80, km: 5, location: "https://maps.app.goo.gl/uiwDYBKiiwCXCmrv9" },
    ],
  },
  {
    name: "Sahakar Nagar",
    city: "Bangalore",
    centers: [
      { id: 77, km: 5, location: "https://maps.app.goo.gl/dtF9wZKi7UpjJYE59" },
    ],
  },
  {
    name: "Siddapura, Whitefield",
    city: "Bangalore",
    centers: [
      { id: 71, km: 5, location: "https://maps.app.goo.gl/K81DXxUfWSe2cxZt8" },
    ],
  },
  {
    name: "Thanisandra",
    city: "Bangalore",
    centers: [
      { id: 96, km: 5, location: "https://maps.app.goo.gl/pAt4Vz2BwsduQ9Ys8" },
    ],
  },
  {
    name: "Thubarahalli",
    city: "Bangalore",
    centers: [
      { id: 82, km: 5, location: "https://maps.app.goo.gl/G2RLg35tzKVji7cF7" },
    ],
  },
  {
    name: "Varthur",
    city: "Bangalore",
    centers: [
      { id: 64, km: 5, location: "https://maps.app.goo.gl/7bHkaSZHCPEJw6118" },
    ],
  },
  {
    name: "Varsova Layout",
    city: "Bangalore",
    centers: [
      { id: 98, km: 5, location: "https://maps.app.goo.gl/PcsXb2EeQQeAoooo7" },
    ],
  },
  {
    name: "Whitefield",
    city: "Bangalore",
    centers: [
      { id: 99, km: 5, location: "https://maps.app.goo.gl/2G44qFyqrVeATayQ9" },
      { id: 97, km: 5, location: "https://maps.app.goo.gl/TwnEAccGi9hZRrYA8" },
      { id: 85, km: 5, location: "https://maps.app.goo.gl/NXNFkqiiYSkJT3bP8" },
      { id: 71, km: 5, location: "https://maps.app.goo.gl/K81DXxUfWSe2cxZt8" },
      { id: 69, km: 5, location: "https://maps.app.goo.gl/hx4sL5tBGHdRd7UY7" },
    ],
  },
  {
    name: "Kukatpally",
    city:"Hyderabad",
    centers: [
      { id: 104, km: 5, location: "https://maps.app.goo.gl/fKvsv891iNg7VV7L8" },
    ],
  },
  {
    name: "Balanagar, Secunderabad",
    city:"Hyderabad",
    centers: [
      { id: 106, km: 5, location: "https://maps.app.goo.gl/YToJjQjWwQnovKBe6" },//kiran
    ],
  },

  {
    name: "L. B. Nagar, Kharmanghat",
    city:"Hyderabad",
    centers: [
      { id: 107, km: 5, location: "https://maps.app.goo.gl/g8QSBfvBZokp8dW99" },//Bad N Pick
    ],
  },
  {
    name: "Bachupally, Pragathi Nagar",
    city:"Hyderabad",
    centers: [
      { id: 109, km: 5, location: "https://maps.app.goo.gl/q6G7bF8afNfusGST6" },//rally
    ],
  },
  {
    name: "Safari Nagar, Prashanth Nagar Colony",
    city:"Hyderabad",
    centers: [
      { id: 112, km: 5, location: "https://maps.app.goo.gl/BjeEMdFEwx1ekY9H9" },//GameInn
    ],
  },
  {
    name: "KNG Pudur Pirivu",
    city:"Coimbatore",
    centers: [
      { id: 108, km: 5, location: "https://maps.app.goo.gl/pBn16m4AVB5G5xVN7" },//coimbore 
    ],
  },
  {
    name: "Hinjawadi",
    city: "Pune",
    centers: [
      { id: 113, km: 5, location: "https://maps.app.goo.gl/daUXe5LPhM36Rzbs7" },//pune
    ],
  },
];
